import React from 'react';
import css from './pin.module.less';
import Row from '@/src/components/Layouts/Row/Row';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Input } from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const PinCollection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { value, onChange, error, pickupPersonName, buyerName } = props;
  return (
    <div className={css.container}>
      <div className={css.titleContainer}>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={getI18n(
                    `allOrders.orderDetail.components_collection_pin_buyerchild`,
                  )}>
                  <NoWrapContainer>
                    <GlobalTooltip title={buyerName}>{buyerName}</GlobalTooltip>
                  </NoWrapContainer>
                </ItemWrapper>
              ),
            },
            {
              child: (
                <ItemWrapper
                  title={getI18n(
                    `allOrders.orderDetail.components_collection_pin_personchild`,
                  )}>
                  <NoWrapContainer>
                    <GlobalTooltip title={pickupPersonName}>
                      {pickupPersonName}
                    </GlobalTooltip>
                  </NoWrapContainer>
                </ItemWrapper>
              ),
            },
          ]}
        />
      </div>
      <ItemWrapper
        title={getI18n(
          `allOrders.orderDetail.components_collection_pin_pinInput`,
        )}>
        <Input
          size='large'
          onChange={onChange}
          value={value}
          error={error}
          help={error}
        />
      </ItemWrapper>
    </div>
  );
};
export default PinCollection;
